import { ToastrService } from 'ngx-toastr';
import { AssignmentStudentAttempt, ClassForListing, StudentVM, LessonProgressReleaseAllModel, LessonProgressReleaseAllByStudent, UnAssignModel } from './../../../Elearning-Models';
import { Observable, Subscription } from 'rxjs';
import { AssignmentFilterService } from '../../../Services/filter.service';
import { SelectionService } from '../../../Services/selection.service';
import { GradebookDataService } from '../../../Services/gradebookData.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { IServiceFactory } from '../../../Services/service-factory';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ReleaseAllDialogComponent } from '../shared/release-all-dialog/release-all-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';

import { UnassignDiaglogComponent } from '../shared/unassign-diaglog/unassign-diaglog.component';

import { ColorCodes } from 'src/app/ColorCodes';


@Component({
	selector: 'app-student',
	templateUrl: './student.component.html',
	styleUrls: ['./student.component.scss']
})
export class StudentComponent implements OnInit, OnDestroy { showCreateAssignments: boolean = false;
	filterSubscription: Subscription;
	studentID: number;
	studentName: string;
	student: StudentVM;
	className: string = "";
	classID: number;
	assignments: AssignmentStudentAttempt[];
	studentDataReceived: boolean = false;
	classOptionsDataReceived: boolean = false;
	lessonVersionID: number = null;
	filterValue: any;
	filteredAssignments: any[];

	classOptions: ClassForListing[] = [];
	filteredClass: Observable<ClassForListing[]>;
	classControl = new FormControl();
	colorIndicators = new ColorCodes().colorIndicators;

	private gradebookDataService: GradebookDataService;
	selectionService: any;
	filterService: AssignmentFilterService;

	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private dialog: MatDialog,
		private serviceFactory: IServiceFactory,
		private toastr: ToastrService
	) {
		this.gradebookDataService = this.serviceFactory.getGradebookDataService();
		this.selectionService = this.serviceFactory.getSelectionService();
		this.filterService = this.serviceFactory.getAssignmentFilterService();
	}

	ngOnInit(): void 
	{
		this.gradebookDataService.ShowGradebookStudentAssignmentCreateAssignmentInterface().subscribe( result => {
		this.showCreateAssignments = result;
	  });
		this.activatedRoute.paramMap.subscribe((params: ParamMap) => 
		{
			this.studentID = Number(params.get('sid'));
			this.classID = Number(params.get('cid'));
		});

		this.activatedRoute.queryParamMap.subscribe(queryParams =>
		{
			this.studentName = queryParams.get('studentName'); 

			if(+queryParams.get('classID')){
				this.classID = +queryParams.get('classID'); 
			}

			if (queryParams.get('lessonVersionID')) {
				//throw("Curriculum ID not supported as query parameter");
			  	this.lessonVersionID = +queryParams.get('lessonVersionID');
        		this.getStudentDetails(this.classID, this.lessonVersionID);
			} else 
			{
        		this.getStudentDetails(this.classID);
      		}
		});

    	this.getClassOptions();

		this.filterSubscription = this.filterService.currentFilterValue.subscribe(filterValue => 
			{
      			this.filterValue = filterValue;
				if(this.studentDataReceived) {
					this.filterAssignments();
				}
			});

  }

  getClassOptions = () => {
	this.gradebookDataService.GetClassListByTeacherAndStudentID(this.studentID).subscribe(response => {
		this.classOptions = response;
		this.classOptionsDataReceived = true;
		this.className = this.classOptions.filter(c => c.HBClassID == this.classID)[0]?.ClassName;

		this.filteredClass = this.classControl.valueChanges
				.pipe(
					startWith(''),
					map(value => this._filterClassByName(value))
		);
	});
  }

	getStudentDetails = (classID, lessonversionID?) => {
    this.studentDataReceived = false;
    if(lessonversionID) {
      this.gradebookDataService.GetLessonProgressByStudentAndLessonVersionID(classID, this.studentID, this.lessonVersionID).subscribe(response => {
        this.student = response;
        this.assignments = this.student?.Assignments;
        this.setClassName(classID);
        this.filterAssignments();
        this.selectionService.setClassID(classID);
        this.studentDataReceived = true;
      });
    } else {
      this.gradebookDataService.GetLessonProgressByStudentID(classID, this.studentID).subscribe(response => {
        this.student = response;
        this.assignments = this.student?.Assignments;
        this.setClassName(classID);
        this.filterAssignments();
        this.selectionService.setClassID(classID);
        this.studentDataReceived = true;
      });
    }

	}

	classChanged = (classID) => {
    if(!this.lessonVersionID) {
      this.getStudentDetails(classID);
    } else {
      this.lessonVersionID = null;
    }
    this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: { classID: classID, lessonVersionID: null }, queryParamsHandling: 'merge' });
	}

	setClassName = (classID) => {
		if (this.classOptions.length) {
			this.className = this.classOptions.filter(c => c.HBClassID == classID)[0].ClassName;
		}
	}

	filterAssignmentsByID = (assignmentIDs) => {
		return this.student?.Assignments?.filter(a => assignmentIDs.includes(a.AssignmentID))
	}

	filterAssignments = () => {
			this.filteredAssignments = [];
			this.assignments?.map(a => {
				if (this.filterService.showData(a)) {
					this.filteredAssignments.push(a);
				}
			});
  }

	clearClassValue = () => {
		this.classControl.setValue('');
	}

	private _filterClassByName(value: string): ClassForListing[] {
		const filterValue = value.toLowerCase();
		return this.classOptions.filter(option => option.ClassName.toLowerCase().includes(filterValue));
	}
	onUnassignAll(){
		const dialogRef = this.dialog.open(UnassignDiaglogComponent, {
			data: {
			  studentName: this.student.StudentName,
			},
			autoFocus: false,
		  });
	  
		  const sub = dialogRef.componentInstance.unassignYes.subscribe(
			(result: boolean) => {
			  if(result){
				this.onUnassignAllClick();
			  }
			}
		  );
	  
		  dialogRef.afterClosed().subscribe((result) => {
			sub.unsubscribe();
		  });
	}
	onUnassignAllClick(){
		var model = new UnAssignModel();
    	model.ClassID = this.classID;
		model.StudentID = this.student.StudentID;
		model.LessonVersionID = null;
    	this.gradebookDataService.UnassignOneOrAll(model).subscribe(result => {
			if(result){
				this.toastr.success(this.student.StudentName + " was successfully unassigned from all assignments.");
			}
			else{
				this.toastr.error('Something went wrong', 'Failure!');
			}
		});
	}

	onReleaseAll = () => {
		const dialogRef = this.dialog.open(ReleaseAllDialogComponent, {
			data: {
				data: this.assignments,
				title: this.student.StudentName,
				type: 'Assignments'
			},
			autoFocus: false,
			panelClass: 'app-release-all-dialog'
		});

		const sub = dialogRef.componentInstance.releaseAllSelected.subscribe(selectedValues => 
			{
				var model = new LessonProgressReleaseAllByStudent();
					model.Threshold= selectedValues.threshold,
					model.Reassign= selectedValues.reassign,
					model.ClassID= this.student.ClassDetails.ClassID,
					model.ReassignShowIcon= selectedValues.reassignOption,
					model.ReassignShowAnswer= selectedValues.reassignSubOption,
					model.StudentID= this.studentID
				

				this.gradebookDataService.ReleaseAllGradesByStudentID(model).subscribe(response => {
					if (response) {
					this.toastr.success('All Students Released', 'Success!');
					} else {
					this.toastr.error('Something went wrong', 'Failure!');
					}
				});
			});

		dialogRef.afterClosed().subscribe(result => {
			sub.unsubscribe();
		});
	}

	trackByFn(index, item) {
		return item.AttemptID;
	}

	toClass = () => {
		const currentClass = localStorage.getItem('classID');
		if (currentClass) {
			this.router.navigate([environment.rootPath + 'Class/' + currentClass]);
		} else {
			// this.router.navigate([environment.rootPath + 'landing']);
		}
	}

	ngOnDestroy(): void {
		this.filterSubscription.unsubscribe();
	}

	/**
	 * This method is used to assign to class with selected student.
	 */
	redirectToAssignedClass = () => {
		this.router.navigate(
		  [environment.rootPath + 'Class/' + this.classID],
		  {
			queryParams: {
			  studentId: this.studentID
			},
		  }
		);
	  }
}
